import React from 'react'
import { useTranslation } from 'react-i18next'

// style components
import { Container, Section, Title, Subtitle } from './DeleteAccount.style'

// utils
import { openEmailClient } from '../../utils/openEmailClient.utils'

// constants
import { deleteEmailAddress } from '../../constants/emails.consts'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'

const DeleteAccount = () => {
    const { t } = useTranslation()

    return (
        <>
            <Title>{t('profile.delete.title')}</Title>
            <Container>
                <Subtitle>{t('profile.delete.text')}</Subtitle>
                <Section>{t('profile.delete.paragraphOne')}</Section>
                <Subtitle>{t('profile.delete.sectionTwoTitle')}</Subtitle>
                <Section>{t('profile.delete.paragraphTwo')}</Section>
                <Button
                    id="delete-account-btn"
                    $size={BUTTON_SIZE.medium}
                    $kind={BUTTON_KIND.primary}
                    overrides={{
                        BaseButton: {
                            style: {
                                width: '100%'
                            }
                        }
                    }}
                    onClick={() => {
                        openEmailClient(deleteEmailAddress)
                    }}
                >
                    <div>{t('profile.delete.confirm')}</div>
                </Button>
            </Container>
        </>
    )
}

export default DeleteAccount
